module.exports = __webpack_public_path__ + "img/logo.ec6b7974.svg";